const initBlocks = () => {
    initSubmenu()
    // initMenuMobile()
    initTooltip()
    initModal()
    initRingStats()
    initBarStats()
    initExpanders()


    // initBlockQuote()
    // initBlockGallery()
    // initBlockCarousel()
    // initBlockAudio()
    // initBlockAccordion()
}

windowReady(() => {
    initBlocks()
});
